module.exports = __webpack_public_path__ + "static/media/Gotham-XLightItalic.39548620.ttf";